/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { loginWithGoogle } from '../../../actions/auth'

import GoogleSignUp from './GoogleSignUp'

import type { OpenIdLoginArgs } from '@/actions/auth/auth'
import type { ReduxState, ThunkDispatch } from '@/types/redux'
import type { RouteComponentProps } from 'react-router'
import type { GoogleSignUpDispatchProps, SignUpProps } from '../types'

interface StateProps {}

interface ConsumerProps extends RouteComponentProps {
  fullText?: boolean
  redirectTo?: string
}

const mapStateToProps = (
  _state: ReduxState,
  { location: { search } }: ConsumerProps,
): StateProps => ({
  locationQueryString: search,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  loginWithGoogle: (args: OpenIdLoginArgs) => dispatch(loginWithGoogle(args)),
})

export default withRouter(
  connect<StateProps, GoogleSignUpDispatchProps, SignUpProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(GoogleSignUp),
)
